// extracted by css-extract-rspack-plugin
export default {"FieldLabel":"ExpressionWidget-module__FieldLabel___U379s","Footer":"ExpressionWidget-module__Footer___XFjKp","RemoveLink":"ExpressionWidget-module__RemoveLink___DNa0j"};